import type React from 'react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const PAGE_CONTENT_WIDTH_CLASS = 'w-full lg:w-11/12 xl:w-10/12 2xl:w-10/12 mx-auto';

interface PageStripProps {
	children: ReactNode;
	className?: string;
	contentClassName?: string;
	testId?: string;
}

const PageStrip = ({
	children,
	className,
	contentClassName,
	testId
}: PageStripProps): React.JSX.Element => {
	return (
		<section className={cn('w-full', className)} data-testid={testId}>
			<div className="container mx-auto px-5">
				<div className={cn(PAGE_CONTENT_WIDTH_CLASS, contentClassName)}>{children}</div>
			</div>
		</section>
	);
};

export default PageStrip;
